// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("./../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-build-time-data-js": () => import("./../src/pages/build-time-data.js" /* webpackChunkName: "component---src-pages-build-time-data-js" */),
  "component---src-pages-index-js": () => import("./../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-mixed-data-js": () => import("./../src/pages/mixed-data.js" /* webpackChunkName: "component---src-pages-mixed-data-js" */),
  "component---src-pages-run-time-data-js": () => import("./../src/pages/run-time-data.js" /* webpackChunkName: "component---src-pages-run-time-data-js" */)
}

